<div class="navigasjon">
  <div class="handlinger">
    <mat-button-toggle-group [formControl]="visningsmodusKontroll" hideSingleSelectionIndicator="true" aria-label="Visningsmodus" [disabled]="navigasjonDeaktivert()">
      <mat-button-toggle value="liste" data-testid="listevisning">
        <mat-icon>list</mat-icon>
      </mat-button-toggle>
      <mat-button-toggle value="kort" data-testid="kortvisning">
        <mat-icon>grid_on</mat-icon>
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>
</div>

@if (visningsmodusKontroll.value == 'liste') {
  <medlemmer-list [gruppe]="gruppeSomSignal()" [valgtMedlemId]="valgtMedlemSomSignal()"/>
} @else {
  <medlemmer-vis [gruppe]="gruppeSomSignal()!" [valgtMedlemId]="valgtMedlemSomSignal()" />
}
